import HealthPictureTypes from '../../../common/enums/healthPictureTypes';

export const ERROR_MESSAGES = {
  UNEXPECTED_ERROR_CREATING_REQUEST:
    'Ha ocurrido un error inesperado al enviar la solicitud, favor intentar más tarde',
};

export const PAYMENT_METHOD_CODE = {
  TRANSFERENCIA: 3,
  CHEQUE: 2,
};

export const BANK_ACCOUNT_STATUS_CODE = {
  INACTIVO: 0,
  ACTIVO: 1,
  CANCELADO: 2,
};

export const ID_TYPE_CODES = {
  RNC: 1,
  CEDULA: 2,
  PASAPORTE: 3,
};

export const CURRENCY_TYPES = [
  { id: 81, label: 'RD$ Peso' },
  { id: 4, label: 'US$ Dolar' },
];

export const INSURED_TYPE_CODE = {
  HOLDER: 0,
};

export const DOCUMENTS_SETTINGS = {
  PAYMENT_RECEIP: {
    type: HealthPictureTypes.PaymentReceipt,
    description: 'Recibo de pago',
    label: 'Adjuntar Recibo de pago',
    labelIdle: '📎 Recibo de pago',
    required: true,
    files: [] as File[],
  },
  INVOICE: {
    type: HealthPictureTypes.Invoice,
    description: 'Factura',
    label: 'Adjuntar Factura',
    labelIdle: '📎 Factura',
    required: true,
    files: [] as File[],
  },
  INVOICES: {
    type: HealthPictureTypes.Invoices,
    description: 'Facturas',
    label: 'Adjuntar Facturas',
    labelIdle: '📎 Facturas',
    required: true,
    files: [] as File[],
  },
  INVOICES_DETAIL: {
    type: HealthPictureTypes.InvoicesDetail,
    description: 'Detalle de Facturas',
    label: 'Adjuntar Detalle de Facturas',
    labelIdle: '📎 Detalle de Facturas',
    required: true,
    files: [] as File[],
  },
  MEDICAL_HISTORY: {
    type: HealthPictureTypes.MedicalHistory,
    description: 'Historial Clínico',
    label: 'Adjuntar Historial Clínico',
    labelIdle: '📎 Historial Clínico',
    required: true,
    files: [] as File[],
  },
  SURGICAL_NOTE: {
    type: HealthPictureTypes.SurgicalNote,
    description: 'Nota Quirurgica',
    label: 'Adjuntar Nota Quirurgica',
    labelIdle: '📎 Nota Quirurgica',
    required: true,
    files: [] as File[],
  },
  MEDICAL_INDICATION: {
    type: HealthPictureTypes.MedicalIndication,
    description: 'Indicación Médica',
    label: 'Adjuntar Indicación Médica',
    labelIdle: '📎 Indicación Médica',
    required: true,
    files: [] as File[],
  },
  MEDICAL_REPORT: {
    type: HealthPictureTypes.MedicalReport,
    description: 'Informe Médico',
    label: 'Adjuntar Informe Médico',
    labelIdle: '📎 Informe Médico',
    required: true,
    files: [] as File[],
  },
  MEDICAL_NOTES: {
    type: HealthPictureTypes.MedicalNotes,
    description: 'Notas Médicas',
    label: 'Adjuntar Notas Médicas',
    labelIdle: '📎 Notas Médicas',
    required: true,
    files: [] as File[],
  },
  OTHERS: {
    type: HealthPictureTypes.Others,
    description: 'Otros',
    label: 'Adjuntar Otros',
    labelIdle: '📎 Otros',
    required: false,
    files: [] as File[],
  },
};

export const SERVICE_TYPES = [
  {
    serviceCode: 1,
    description: 'Honorarios de Cirugía',
  },
  {
    serviceCode: 2,
    description: 'Consulta',
  },
  {
    serviceCode: 3,
    description: 'Emergencia',
  },
  {
    serviceCode: 4,
    description: 'Laboratorios',
  },
  {
    serviceCode: 5,
    description: 'Estudios',
  },
  {
    serviceCode: 6,
    description: 'Honorarios Ambulatorios',
  },
  {
    serviceCode: 7,
    description: 'Internamiento',
  },
  {
    serviceCode: 8,
    description: 'Medicamentos',
  },
  {
    serviceCode: 9,
    description: 'Terapia Física',
  },
  {
    serviceCode: 10,
    description: 'Vacuna',
  },
];

export const DOCUMENTS_RULES: {
  [serviceCode: number]: {
    type: HealthPictureTypes;
    label: string;
    labelIdle: string;
    required: boolean;
  }[];
} = {
  1: [
    // Honorarios de Cirugía
    DOCUMENTS_SETTINGS.PAYMENT_RECEIP,
    DOCUMENTS_SETTINGS.MEDICAL_HISTORY,
    DOCUMENTS_SETTINGS.SURGICAL_NOTE,
    DOCUMENTS_SETTINGS.OTHERS,
  ],
  2: [
    // Consulta
    DOCUMENTS_SETTINGS.PAYMENT_RECEIP,
    DOCUMENTS_SETTINGS.OTHERS,
  ],
  3: [
    // Emergencia
    DOCUMENTS_SETTINGS.PAYMENT_RECEIP,
    DOCUMENTS_SETTINGS.INVOICES_DETAIL,
    DOCUMENTS_SETTINGS.OTHERS,
  ],
  4: [
    // Laboratorios
    DOCUMENTS_SETTINGS.PAYMENT_RECEIP,
    DOCUMENTS_SETTINGS.MEDICAL_INDICATION,
    DOCUMENTS_SETTINGS.OTHERS,
  ],
  5: [
    // Estudios
    DOCUMENTS_SETTINGS.PAYMENT_RECEIP,
    DOCUMENTS_SETTINGS.MEDICAL_INDICATION,
    DOCUMENTS_SETTINGS.OTHERS,
  ],
  6: [
    // Honorarios Ambulatorio
    DOCUMENTS_SETTINGS.PAYMENT_RECEIP,
    DOCUMENTS_SETTINGS.MEDICAL_INDICATION,
    DOCUMENTS_SETTINGS.MEDICAL_REPORT,
  ],
  7: [
    // Internamiento
    DOCUMENTS_SETTINGS.PAYMENT_RECEIP,
    DOCUMENTS_SETTINGS.INVOICES,
    DOCUMENTS_SETTINGS.MEDICAL_NOTES,
  ],
  8: [
    // Medicamentos
    DOCUMENTS_SETTINGS.PAYMENT_RECEIP,
    DOCUMENTS_SETTINGS.INVOICE,
    DOCUMENTS_SETTINGS.MEDICAL_INDICATION,
    DOCUMENTS_SETTINGS.OTHERS,
  ],
  9: [
    // Terapia Física
    DOCUMENTS_SETTINGS.PAYMENT_RECEIP,
    DOCUMENTS_SETTINGS.INVOICE,
    DOCUMENTS_SETTINGS.MEDICAL_INDICATION,
    DOCUMENTS_SETTINGS.MEDICAL_REPORT,
  ],
  10: [
    // Vacuna
    DOCUMENTS_SETTINGS.PAYMENT_RECEIP,
    DOCUMENTS_SETTINGS.MEDICAL_INDICATION,
    DOCUMENTS_SETTINGS.OTHERS,
  ],
};
